const routes = [
  {
    path: '/stationSchedule',
    name: 'stationSchedule',
    component: () => import('./pages/Home'),
    // redirect: '/carAccessRecord/index',
    meta: {
      requireAuth: false
    },
    children: [
      {
        path: 'exitApproval', // 车辆出园审批
        name: 'exitApproval',
        component: () => import('./pages/ExitApproval'),
        meta: {
          requireAuth: false,
          routerAlive: true
        }
      },
      {
        path: 'carEnterManage', // 车辆预约(入园)管理
        name: 'carEnterManage',
        component: () => import('./pages/CarEnterManage'),
        meta: {
          requireAuth: false,
          routerAlive: true
        }
      },
    ]
  }
]

export default routes